import React, { FC } from 'react';
import { Control, UseFormWatch } from 'react-hook-form';
import { ReportConfigDto } from '@thingslog/repositories';

interface CustomerBillingReportSettingsFormProps {
  control: Control<ReportConfigDto>;
  watch: UseFormWatch<ReportConfigDto>;
}

const CustomerBillingReportSettingsForm: FC<
  CustomerBillingReportSettingsFormProps
> = (): React.ReactElement | null => {
  // No additional settings for customer billing report
  return null;
};

export default CustomerBillingReportSettingsForm;
